/* eslint-disable max-lines */
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Grid, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Buffer } from 'buffer';
import ErrorIcon from '../../images/ErrorX.svg';
import ErrorTriangleIcon from '../../images/ErrorTriangle.svg';
import DoneTick from '../../images/Done.svg';
import DoneTickGreen from '../../images/Done-green.svg';
import NewAddressImage from '../../images/Upload_GIF_1.gif';
import NewAddressSpanish from '../../images/Upload_GIF_1ES.gif';
import { SidebarStyles as classes } from './SidebarStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import cloudUpload from '../../images/cloud-upload.svg';
import uploadBtnIcon from '../../images/upload_btn_icon.svg';
import cameraBtnIcon from '../../images/camera_upload_icon.svg';
import CustomTooltip from '../Tooltip/CustomTooltip';
import Loader from '../Loader/Loader';
import {
  ADDRESSLINE1_MAX_ERR,
  ADDRESSLINE2_MAX_ERR,
  DONE,
  FAILED,
  HOME_PR,
  HOME_VI,
  MANDATORY_FIELD_ERR,
  NAME_MISMATCH_ERROR,
  ORIENTAL_ORANGE,
  UPLOAD_ADDRESS_GIF_TEXT,
} from '../../constants';
import {
  generateFileMD5,
  uploadDocument,
  uploadDocumentByPreSignedURL,
  uploadDocumentXL,
} from '../../services/uploadService';
import { commonUtility, commonUtilityValueReturn } from '../LeadGeneration/UtilityFunctions';
import { getOcrAddressValidation } from '../../services/formService';
import { productMapping } from '../../services/productMapping';
import { productNameURLMapping } from '../../services/productNameURLMapping';
import { businessMapping } from '../../services/businessMapping';
import { dgiMapping } from '../../services/dgiMapping';
import {
  clearUploadFocus,
  commonTernary,
  isBundle,
  productsNotEligibleForUsAddress,
  zipCodeValueSetError,
} from '../commonCode';
import BillTypeCustomCard from '../Bundle/BillTypeCustomCard';
import { CameraUpload, CloudUpload, CloudUploadBtn } from '../../images/svg/CustomizedSVG';

const setOcrVerified = (resp, leadGenerationContext) => {
  const {
    personalInformation,
    businessContactInformation,
    setAddressDocLoading,
    setAddressProofUploadStatus,
    setAddressInformation,
  } = leadGenerationContext;
  let ocrVerified = false;
  const customerFullName = resp?.data?.CustomerName?.toLowerCase();
  if (
    (customerFullName?.includes(personalInformation?.firstName?.toLowerCase()) &&
      customerFullName?.includes(personalInformation?.lastName?.toLowerCase())) ||
    (customerFullName?.includes(businessContactInformation?.firstName?.toLowerCase()) &&
      customerFullName?.includes(businessContactInformation?.lastName?.toLowerCase()))
  ) {
    setAddressDocLoading(false);
    setAddressProofUploadStatus(DONE);
    ocrVerified = true;
  } else {
    setAddressInformation((prevState) => ({
      ...prevState,
      ocrUIErrors: NAME_MISMATCH_ERROR,
    }));
    setAddressDocLoading(false);
    setAddressProofUploadStatus(FAILED);
  }
  return ocrVerified;
};
const errorMessageFromMS = (ocrResp, leadGenerationContext) => {
  let errorMessage;
  const {
    setAddressInformation,
    setIsOcrErrMessageFound,
    ocrErrorMessageArr,
    setOcrErrorMessageArr,
  } = leadGenerationContext;
  if (ocrResp.status) {
    errorMessage = ocrResp.data.Message;
    if (errorMessage !== null || errorMessage !== undefined) {
      setAddressInformation((prevState) => ({ ...prevState, ocrErrorMessage: errorMessage }));
      if (!ocrErrorMessageArr.includes(errorMessage)) {
        ocrErrorMessageArr.push(errorMessage);
      }
      setOcrErrorMessageArr(ocrErrorMessageArr);
      setIsOcrErrMessageFound(true);
    } else {
      setIsOcrErrMessageFound(false);
      setOcrErrorMessageArr([]);
    }
  }
};
const getOCRAddressDetails = async (response, leadGenerationContext, props) => {
  const { vouchedAddrEdited, setHomeAddressUploadDocId } = props;
  const {
    setAddressProofUploadStatus,
    setAddressInformation,
    businessHomeAddress,
    setBusinessHomeAddress,
    productName,
    setBusinessHomeAddressErrors,
    addressInformation,
    accessToken,
    setOcrResponse,
    setOcrErrorMessageArr,
    setAddressInformationErrors,
    setAddressDocLoading,
    setPopupModalIntial,
  } = leadGenerationContext;

  const data = { ...addressInformation };
  data.docId = response.documentId;
  data.docFormat = response.format;
  data.billType = addressInformation?.utilityBill || businessHomeAddress?.utilityBill;
  const ocrResponse = await getOcrAddressValidation(data, accessToken);

  // const ocrResponse = {
  //   status: 200,
  //   data: {
  //     Country: 'USA',
  //     AddressLine1: 'AddressLine1',
  //     AddressLine2: 'AddressLine2',
  //   },
  // };

  if (ocrResponse?.data && ocrResponse?.status === 200) {
    setOcrResponse(true);
    setHomeAddressUploadDocId(response.documentId);
    setPopupModalIntial(true);
    if (addressInformation.ocrUIErrors === NAME_MISMATCH_ERROR) {
      if (businessMapping(productName)) {
        setBusinessHomeAddress((prevState) => ({
          ...prevState,
          address1: ocrResponse.data.AddressLine1,
          address2: ocrResponse.data.AddressLine2,
          state: commonUtility(ocrResponse.data.State),
          country: commonUtility(ocrResponse.data.Country),
          city: commonUtility(ocrResponse.data.City),
          zipCode: commonUtility(ocrResponse.data.ZipCode),
          vouchedAddrEdited,
        }));
      } else {
        setAddressInformation((prevState) => ({
          ...prevState,
          address1: ocrResponse.data.AddressLine1,
          address2: ocrResponse.data.AddressLine2,
          state: commonUtility(ocrResponse.data.State),
          country: commonUtility(ocrResponse.data.Country),
          city: commonUtility(ocrResponse.data.City),
          zipCode: commonUtility(ocrResponse.data.ZipCode),
          vouchedAddrEdited,
        }));
      }
      if (addressInformation?.sameMailingAddress) {
        setAddressInformation((prevState) => ({
          ...prevState,
          permanentAddress1: ocrResponse.data.AddressLine1,
          permanentAddress2: ocrResponse.data.AddressLine2,
          permanentState: commonUtility(ocrResponse.data.State),
          permanentCountry: commonUtility(ocrResponse.data.Country),
          permanentCity: commonUtility(ocrResponse.data.City),
          permanentZipCode: commonUtility(ocrResponse.data.ZipCode),
        }));
      }
      setAddressInformationErrors((prevState) => ({
        ...prevState,
        address1: ocrResponse.data.AddressLine1?.length > 30 ? ADDRESSLINE1_MAX_ERR : '',
        address2: ocrResponse.data.AddressLine2?.length > 30 ? ADDRESSLINE2_MAX_ERR : '',
        state: '',
        country: '',
        city: '',
        zipCode: zipCodeValueSetError(ocrResponse.data.ZipCode),
        permanentAddress1: '',
        permanentAddress2: '',
        permanentState: '',
        permanentCountry: '',
        permanentCity: '',
        permanentZipCode: zipCodeValueSetError(ocrResponse.data.ZipCode),
      }));
    }
    if (businessMapping(productName)) {
      setBusinessHomeAddress((prevState) => ({
        ...prevState,
        address1: ocrResponse.data.AddressLine1,
        address2: ocrResponse.data.AddressLine2,
        state: commonUtility(ocrResponse.data.State),
        country: commonUtility(ocrResponse.data.Country),
        city: commonUtility(ocrResponse.data.City),
        zipCode: commonUtility(ocrResponse.data.ZipCode),
        vouchedAddrEdited,
      }));
    } else if (
      productsNotEligibleForUsAddress(productName) &&
      commonUtility(ocrResponse.data.Country) !== 'PR'
    ) {
      setAddressDocLoading(false);
      setHomeAddressUploadDocId(response.documentId);
      errorMessageFromMS(ocrResponse, leadGenerationContext);
      setAddressProofUploadStatus(FAILED);
      setPopupModalIntial(false);
    } else {
      setAddressInformation((prevState) => ({
        ...prevState,
        address1: ocrResponse.data.AddressLine1,
        address2: ocrResponse.data.AddressLine2,
        state: commonUtility(ocrResponse.data.State),
        country: commonUtility(ocrResponse.data.Country),
        city: commonUtility(ocrResponse.data.City),
        zipCode: commonUtility(ocrResponse.data.ZipCode),
        vouchedAddrEdited,
      }));
    }
    if (addressInformation?.sameMailingAddress) {
      setAddressInformation((prevState) => ({
        ...prevState,
        permanentAddress1: ocrResponse.data.AddressLine1,
        permanentAddress2: ocrResponse.data.AddressLine2,
        permanentState: commonUtility(ocrResponse.data.State),
        permanentCountry: commonUtility(ocrResponse.data.Country),
        permanentCity: commonUtility(ocrResponse.data.City),
        permanentZipCode: commonUtility(ocrResponse.data.ZipCode),
      }));
    }
    setAddressInformationErrors((prevState) => ({
      ...prevState,
      address1: ocrResponse.data.AddressLine1?.length > 30 ? ADDRESSLINE1_MAX_ERR : '',
      address2: ocrResponse.data.AddressLine2?.length > 30 ? ADDRESSLINE2_MAX_ERR : '',
      state: '',
      country: '',
      city: '',
      zipCode: zipCodeValueSetError(ocrResponse.data.ZipCode),
      permanentAddress1: '',
      permanentAddress2: '',
      permanentState: '',
      permanentCountry: '',
      permanentCity: '',
      permanentZipCode: zipCodeValueSetError(ocrResponse.data.ZipCode),
    }));
    setBusinessHomeAddressErrors((prevState) => ({
      ...prevState,
      address1: '',
      address2: '',
      state: '',
      country: '',
      city: '',
      zipCode: zipCodeValueSetError(ocrResponse.data.ZipCode),
    }));

    const isVerified = setOcrVerified(ocrResponse, leadGenerationContext);
    if (businessMapping(productName))
      setBusinessHomeAddress((prevState) => ({ ...prevState, ocrAddressVerified: isVerified }));
    else setAddressInformation((prevState) => ({ ...prevState, ocrAddressVerified: isVerified }));

    // error response from MS
  } else if (ocrResponse?.status === 400) {
    setAddressDocLoading(false);
    setHomeAddressUploadDocId(response.documentId);
    errorMessageFromMS(ocrResponse, leadGenerationContext);
    setAddressProofUploadStatus(FAILED);
    setPopupModalIntial(false);
  }
  // OCR Api down
  else if (ocrResponse?.status === 500 || ocrResponse?.status === 404) {
    setAddressDocLoading(false);
    setAddressProofUploadStatus(DONE);
    setPopupModalIntial(false);
  } else {
    setAddressDocLoading(false);
    setAddressProofUploadStatus(FAILED);
    setPopupModalIntial(false);
  }
};
const getDataResponse = async (
  response,
  file,
  fileMd5Base64,
  fileType1,
  leadGenerationContext,
  props
) => {
  const { setAddressProofUploadStatus, setAddressDocLoading } = leadGenerationContext;
  if (response.data) {
    const documentId = commonUtility(response.data.documentId);
    const preSignedUrl = commonUtility(response.data.preSignedUrl);
    if (preSignedUrl && documentId) {
      const resp = await uploadDocumentByPreSignedURL(
        preSignedUrl,
        file,
        fileMd5Base64,
        leadGenerationContext.setStatementUploadProgress,
        leadGenerationContext.setStatementLinearProgress
      );
      if (resp && resp.status === 200) {
        handleAddressUpload(leadGenerationContext, props, fileType1, response, file, documentId);
      } else {
        setAddressDocLoading(false);
        setAddressProofUploadStatus(FAILED);
      }
    }
  }
};
const handleAddressUpload = async (
  leadGenerationContext,
  props,
  fileType1,
  response,
  file,
  documentId
) => {
  const {
    addressInformation,
    setAddressProofUploadStatus,
    setAddressDocLoading,
    businessHomeAddress,
  } = leadGenerationContext;
  const { setHomeAddressUploadDocId } = props;
  if (
    fileType1 === 'Home Address Proof' &&
    (businessHomeAddress.utilityBill === 'LUMA' ||
      businessHomeAddress.utilityBill === 'AAA' ||
      addressInformation.utilityBill === 'LUMA' ||
      addressInformation.utilityBill === 'AAA')
  ) {
    const res = response.data;
    const fileName = file.name;
    const fileParts = fileName.split('.');
    const fileExtension = fileParts[fileParts.length - 1].toLowerCase();
    res.format = fileExtension;
    await getOCRAddressDetails(res, leadGenerationContext, props);
  } else if (fileType1 === 'Home Address Proof') {
    setHomeAddressUploadDocId(documentId);

    setAddressDocLoading(false);
    setAddressProofUploadStatus(DONE);
  } else {
    setAddressDocLoading(false);
    setAddressProofUploadStatus(FAILED);
  }
};
const documentResponse = async (...args) => {
  const fileMD5 = args[0];
  const fileExtension = args[1];
  const fileName = args[2];
  const fileType1 = args[3];
  const fileSize = args[4];
  const file = args[5];
  const leadGenerationContext = args[6];
  const props = args[7];
  const { setAddressProofUploadStatus, setAddressDocLoading } = leadGenerationContext;
  if (fileMD5) {
    const fileMd5Base64 = Buffer.from(fileMD5, 'hex').toString('base64');
    const response = await uploadDocumentXL(
      fileExtension,
      fileName,
      fileType1,
      fileSize,
      fileMd5Base64,
      leadGenerationContext.accessToken,
      leadGenerationContext.setStatementUploadProgress,
      leadGenerationContext.setStatementLinearProgress,
      { isWCFlow: leadGenerationContext?.wcFlow, env: leadGenerationContext?.environment }
    );

    if (response) {
      await getDataResponse(response, file, fileMd5Base64, fileType1, leadGenerationContext, props);
    } else {
      setAddressDocLoading(false);
      setAddressProofUploadStatus(FAILED);
    }
  } else {
    setAddressDocLoading(false);
    setAddressProofUploadStatus(FAILED);
  }
};
export const uploadFile = async (file, leadGenerationContext, props) => {
  const { fileType } = props;
  const {
    setAddressInformation,
    setAddressProofUploadStatus,
    addressInformation,
    setAddressDocLoading,
  } = leadGenerationContext;
  setAddressDocLoading(true);
  const fileName = file.name;
  const fileParts = fileName.split('.');
  const fileExtension = fileParts[fileParts.length - 1].toLowerCase();
  const fileSize = file.size;

  if (fileSize > 10485760) {
    setAddressDocLoading(false);
    setAddressInformation((prevState) => ({ ...prevState, ocrErrorMessage: '' }));
    setAddressInformation((prevState) => ({
      ...prevState,
      ocrUIErrors: `The file exceeds the maximum upload size (10 Mb).`,
    }));
    setAddressProofUploadStatus(FAILED);
    return;
  }

  const extensions = ['pdf', 'jpg', 'jpeg', 'png'];

  let isValidExtension = false;
  if (extensions.includes(fileExtension.toLowerCase())) isValidExtension = true;
  if (!isValidExtension) {
    setAddressDocLoading(false);
    setAddressProofUploadStatus(FAILED);
    setAddressInformation((prevState) => ({
      ...prevState,
      ocrUIErrors: 'Only files with the following formats are allowed: PNG, JPG, PDF.',
    }));
    return;
  }

  const formData = new FormData();
  formData.append('file', file);

  if (fileSize > 3145728) {
    const fileMD5 = await generateFileMD5(file);
    await documentResponse(
      fileMD5,
      fileExtension,
      fileName,
      fileType,
      fileSize,
      file,
      leadGenerationContext,
      props
    );
  } else {
    const response = await uploadDocument(
      fileExtension,
      fileName,
      fileType,
      formData,
      leadGenerationContext.accessToken,
      leadGenerationContext.setStatementUploadProgress,
      leadGenerationContext.setStatementLinearProgress,
      { isWCFlow: leadGenerationContext?.wcFlow, env: leadGenerationContext?.environment }
    );

    if (response?.data) {
      handleFileType(fileType, addressInformation, response, leadGenerationContext, props);
    } else {
      setAddressDocLoading(false);
      setAddressProofUploadStatus(FAILED);
    }
  }
};
const handleFileType = async (
  fileType,
  addressInformation,
  response,
  leadGenerationContext,
  props
) => {
  const { setHomeAddressUploadDocId } = props;
  const { setAddressProofUploadStatus, setAddressDocLoading, businessHomeAddress } =
    leadGenerationContext;
  if (
    fileType === 'Home Address Proof' &&
    (businessHomeAddress.utilityBill === 'LUMA' ||
      businessHomeAddress.utilityBill === 'AAA' ||
      addressInformation.utilityBill === 'LUMA' ||
      addressInformation.utilityBill === 'AAA')
  ) {
    await getOCRAddressDetails(response.data, leadGenerationContext, props);
    setHomeAddressUploadDocId(response.data.documentId);
  } else if (fileType === 'Home Address Proof') {
    setHomeAddressUploadDocId(response.data.documentId);
    setAddressDocLoading(false);
    setAddressProofUploadStatus(DONE);
  } else {
    setAddressDocLoading(false);
    setAddressProofUploadStatus(FAILED);
  }
};
function DocumentUploadSidebar(props) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    addressProofUploadStatus,
    productName,
    addressInformation,
    setAddressInformation,
    setAddressInformationErrors,
    setIsOcrErrMessageFound,
    isOcrErrMessageFound,
    location,
    addressDocLoading,
    businessHomeAddress,
    setBusinessHomeAddress,
    setBusinessHomeAddressErrors,
    newAddress,
    theme,
  } = leadGenerationContext;
  const fileInput = useRef(null);
  const { vouchedAddrEdited, history, pagePath, isBundleFlag, handleChange } = props;
  const [checkFlow, setCheckFlow] = useState('');
  useEffect(() => {
    if (businessMapping(productName)) {
      setCheckFlow('commercial-form');
    } else {
      setCheckFlow('retail-form');
    }
  }, []);
  const validCheckOne =
    (productMapping(productName) && location === HOME_PR) || dgiMapping(productName);
  const validCheckTwo = businessMapping(productName) && businessHomeAddress?.vouchedAddrEdited;

  const checkFileInput = () => {
    if (fileInput?.current?.value) {
      fileInput.current.value = '';
    }
  };
  const buttonClickHandler = (e) => {
    e.preventDefault();
    clearUploadFocus();
    if (
      (validCheckOne &&
        addressInformation?.vouchedAddrEdited &&
        (newAddress || addressInformation.retainUtilityBill)) ||
      (validCheckOne && !addressInformation.vouchedAddressVerified)
    ) {
      if (!addressInformation?.utilityBill) {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          utilityBill: MANDATORY_FIELD_ERR,
        }));
        utitliyBillFocus();
      } else {
        checkFileInput();
        fileInput.current?.click();
        setIsOcrErrMessageFound(false);
        setAddressInformation((prevState) => ({
          ...prevState,
          ocrErrMessage: '',
        }));
        setAddressInformation((prevState) => ({
          ...prevState,
          ocrUIErrors: '',
        }));
      }
    } else if (validCheckTwo) {
      if (!businessHomeAddress?.utilityBill) {
        setBusinessHomeAddressErrors((prevState) => ({
          ...prevState,
          utilityBill: MANDATORY_FIELD_ERR,
        }));
        utitliyBillFocus();
      } else {
        checkFileInput();
        fileInput.current?.click();
        setIsOcrErrMessageFound(false);
        setAddressInformation((prevState) => ({
          ...prevState,
          ocrErrMessage: '',
        }));
        setAddressInformation((prevState) => ({
          ...prevState,
          ocrUIErrors: '',
        }));
      }
    } else {
      checkFileInput();
      fileInput.current?.click();
      setIsOcrErrMessageFound(false);
      setAddressInformation((prevState) => ({
        ...prevState,
        ocrErrMessage: '',
      }));
      setBusinessHomeAddress((prevState) => ({
        ...prevState,
        ocrUIErrors: '',
      }));
    }
  };

  const utitliyBillFocus = () => {
    const element = document?.getElementById('utilityBill');
    element?.focus();
  };

  const fileInputHandler = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file !== undefined && file !== null) {
      if (isBundle(productName)) {
        setAddressInformation((prevState) => ({
          ...prevState,
          editHomeAddress: true,
        }));
      }
      uploadFile(file, leadGenerationContext, props);
    }
  };

  let addrUploadJsx;
  const vouchedEditAddrUploadNotDone = () => {
    if (
      (vouchedAddrEdited && addressProofUploadStatus !== DONE && !addressDocLoading) ||
      (!addressInformation.vouchedAddressVerified && addressProofUploadStatus !== DONE)
    ) {
      if (leadGenerationContext.language === 'EN') {
        addrUploadJsx = (
          <Box component="div" sx={classes.new_addr_gif}>
            <Box
              component="img"
              id="newAddrGIF"
              tabIndex="0"
              sx={classes.new_addr_gif_width_adjust}
              src={NewAddressImage}
              alt={t(`AddressProofGif`, {
                defaultValue: UPLOAD_ADDRESS_GIF_TEXT,
              })}
            />
          </Box>
        );
      } else {
        addrUploadJsx = (
          <Box component="div" sx={classes.new_addr_gif}>
            <Box
              component="img"
              id="newAddrGIF"
              tabIndex="0"
              sx={classes.new_addr_gif_width_adjust}
              src={NewAddressSpanish}
              alt={t(`AddressProofGif`, {
                defaultValue: UPLOAD_ADDRESS_GIF_TEXT,
              })}
            />
          </Box>
        );
      }
    }
    return addrUploadJsx;
  };

  const ErrorUploadIcon = commonUtilityValueReturn(
    isBundle(productName),
    ErrorTriangleIcon,
    ErrorIcon
  );

  const addressProofUploadFail = () => {
    if (addressProofUploadStatus === FAILED && !addressDocLoading) {
      addrUploadJsx = (
        <Box component="div" sx={classes.statusContainer} tabIndex="0" width="100%">
          <img
            id="uploadAddressProofFail"
            src={ErrorUploadIcon}
            data-testid="upload_failed_id"
            onClick={(e) => buttonClickHandler(e)}
            onKeyDown={(e) => buttonClickHandler(e)}
            alt="Upload Failed"
            height="54px"
            width="54px"
          />
          <Box
            component="span"
            sx={[
              classes.errorText,
              ...(isBundle(productName)
                ? [{ fontSize: '20px', fontWeight: 700, color: '#D5151F', padding: '0 0 10px 0' }]
                : []),
            ]}
          >
            {commonTernary(
              isBundle(productName),
              t('Oops! There was an error', {
                defaultValue: 'Oops! There was an error',
              }),
              t('Try Again', {
                defaultValue: 'Try Again',
              })
            )}
          </Box>
          {isBundle(productName) && (
            <Box component="span" style={{ width: '75%' }}>
              <Box component="div" sx={classes.errorTextBundle}>
                {isOcrErrMessageFound
                  ? t(addressInformation.ocrErrorMessage, {
                      defaultValue: addressInformation.ocrErrorMessage,
                      nsSeparator: '|',
                    })
                  : t(addressInformation.ocrUIErrors, {
                      defaultValue: addressInformation.ocrUIErrors,
                      nsSeparator: '|',
                    })}
              </Box>
              <Box component="div" sx={classes.errorTextBundle}>
                <Box
                  component="span"
                  sx={{ fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={(e) => buttonClickHandler(e)}
                  onKeyDown={(e) => buttonClickHandler(e)}
                  tabIndex={0}
                >
                  {t('Click to upload', {
                    defaultValue: 'Click to upload',
                  })}
                </Box>
                {t(' the document again.', {
                  defaultValue: ' the document again.',
                })}
              </Box>
            </Box>
          )}
        </Box>
      );
    }
    return addrUploadJsx;
  };

  const acceptFileType = () => {
    let file;
    if (addressInformation?.utilityBill === 'LUMA' || addressInformation?.utilityBill === 'AAA')
      file = '.pdf,.jpg,.png';
    else
      file =
        '.pdf,.jpg,.jpeg,.png,.jfif,.bmp,.bpm,.pgm,.ppm,.gif,.gifv,.tiff,.heic,.heif,.hevc,.mpg,.mpeg';
    return file;
  };
  useEffect(() => {
    let element = '';
    element = document.getElementById('uploadContainer');
    if (element) {
      if (isBundle(productName)) {
        if (addressProofUploadStatus === DONE && !addressDocLoading) {
          const backgroundColor = leadGenerationContext.isLightTheme ? '#E7F3E6' : '#0B6C0333';
          element.setAttribute(
            'style',
            `background-image: repeating-linear-gradient(0deg,#76BB70,#76BB70 7px,transparent 8px,transparent 15px),
                        repeating-linear-gradient(90deg,#76BB70,#76BB70 7px,transparent 8px,transparent 15px),
                        repeating-linear-gradient(180deg,#76BB70,#76BB70 7px,transparent 8px,transparent 15px),
                        repeating-linear-gradient(270deg,#76BB70,#76BB70 7px,transparent 8px,transparent 15px) !important;
     background: ${backgroundColor};
     background-size: 1.5px 100%, 100% 1.5px, 1.5px 100%, 100% 1.5px;
     background-repeat: no-repeat;
     background-position: 0 0, 0 0, 100% 0, 0 100%`
          );
        } else if (addressProofUploadStatus === FAILED && !addressDocLoading) {
          const backgroundColor = leadGenerationContext.isLightTheme ? '#FBE8E9' : '#D5151F1A';
          element.setAttribute(
            'style',
            `background-image: repeating-linear-gradient(0deg,#FF6971,#FF6971 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#FF6971,#FF6971 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#FF6971,#FF6971 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#FF6971,#FF6971 7px,transparent 8px,transparent 15px) !important;  background: ${backgroundColor};background-size: 1.5px 100%, 100% 1.5px, 1.5px 100%, 100% 1.5px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%`
          );
        }
      } else if (addressProofUploadStatus === DONE && !addressDocLoading) {
        element.setAttribute(
          'style',
          'background-image: repeating-linear-gradient(0deg,#E37617,#E37617 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#E37617,#E37617 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#E37617,#E37617 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#E37617,#E37617 7px,transparent 8px,transparent 15px) !important; background:#FFFDF2;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
        );
      } else if (addressProofUploadStatus === FAILED && !addressDocLoading) {
        element.setAttribute(
          'style',
          'background-image: repeating-linear-gradient(0deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#D71721,#D71721 7px,transparent 8px,transparent 15px) !important; background:#FFF2F2;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
        );
      } else {
        element?.setAttribute(
          'style',
          'background-image: repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px) !important; background:#F4F4F4;background-size: 1.5px 100%, 100% 1.5px, 1.5px 100%, 100% 1.5px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
        );
      }
    }
  }, [addressProofUploadStatus, leadGenerationContext.isLightTheme]);

  const routeToCameraUpload = () => {
    clearUploadFocus();
    if (validCheckOne) {
      if (!addressInformation?.utilityBill) {
        setAddressInformationErrors((prevState) => ({
          ...prevState,
          utilityBill: MANDATORY_FIELD_ERR,
        }));
        utitliyBillFocus();
      } else {
        setIsOcrErrMessageFound(false);
        setAddressInformation((prevState) => ({
          ...prevState,
          ocrErrMessage: '',
        }));
        setAddressInformation((prevState) => ({
          ...prevState,
          ocrUIErrors: '',
        }));
        history.push({
          pathname: `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/${checkFlow}/${productNameURLMapping(
            productName
          )}/camera-upload`,
          redirectingPath: pagePath,
          pageProps: props,
          flow: checkFlow,
        });
      }
    } else if (validCheckTwo) {
      if (!businessHomeAddress?.utilityBill) {
        setBusinessHomeAddressErrors((prevState) => ({
          ...prevState,
          utilityBill: MANDATORY_FIELD_ERR,
        }));
        utitliyBillFocus();
      } else {
        setIsOcrErrMessageFound(false);
        setBusinessHomeAddress((prevState) => ({
          ...prevState,
          ocrErrMessage: '',
        }));
        setBusinessHomeAddress((prevState) => ({
          ...prevState,
          ocrUIErrors: '',
        }));
        history.push({
          pathname: `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/${checkFlow}/${productNameURLMapping(
            productName
          )}/camera-upload`,
          redirectingPath: pagePath,
          pageProps: props,
          flow: checkFlow,
        });
      }
    } else {
      if (location === 'VI' && addressInformation?.vouchedAddrEdited) {
        history.push({
          pathname: `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/${checkFlow}/${productNameURLMapping(
            productName
          )}/camera-upload`,
          redirectingPath: pagePath,
          pageProps: props,
          flow: checkFlow,
        });
      }
      setIsOcrErrMessageFound(false);
      setAddressInformation((prevState) => ({
        ...prevState,
        ocrErrMessage: '',
      }));
    }
  };

  const successUploadImg = commonUtilityValueReturn(isBundle(productName), DoneTickGreen, DoneTick);
  return (
    <Grid container>
      {/* <Grid size={{ xs: 12 }}>
        <Typography
          variant="h2"
          data-testid="address-proof"
          className={
            businessFlow
              ? `${classes.top_text_upload_id} ${classes.business_top_text_upload_id}`
              : classes.top_text_upload_id
          }
        >
          {t('Upload Address Proof', { defaultValue: 'Upload Address Proof' })}
          <span style={{ fontSize: '22px', marginLeft: '5px', color: ORIENTAL_ORANGE }}>*</span>
          <span style={{ marginLeft: '10px', opacity: 1 }}>
            <CustomTooltip
              placement="top"
              text={t(`PreviewAddressConsent`, {
                defaultValue: `Address proof is required to open your account if your current home address is not available on your ID. You will need to provide a utility bill with your name and address issued within the last 60 days.`,
              })}
            />
          </span>
        </Typography>
      </Grid> */}

      {!addressInformation.vouchedAddressVerified ||
      (vouchedAddrEdited && addressProofUploadStatus !== DONE) ? (
        <input
          type="file"
          data-testid="inp-test"
          accept={acceptFileType()}
          onChange={fileInputHandler}
          ref={fileInput}
          style={{ display: 'none' }}
        />
      ) : (
        ''
      )}
      <Grid size={{ xs: 12 }} sx={classes.id_upload_grid}>
        <Box
          component="div"
          style={{ paddingTop: isBundle(productName) ? '0px' : '20px', width: '100%' }}
          sx={pagePath === 'business-account-info' ? classes.busiAccWidth : ''}
        >
          <Box sx={classes.top_text_upload_id}>
            {!isBundleFlag && (
              <>
                <Typography
                  variant="h2"
                  data-testid="address-proof"
                  sx={classes.top_text_upload_id}
                >
                  {t('Upload Home Address Proof', { defaultValue: 'Upload Home Address Proof' })}
                  <span style={{ fontSize: '22px', marginLeft: '5px', color: ORIENTAL_ORANGE }}>
                    *
                  </span>
                </Typography>
                <span style={{ marginLeft: '10px', opacity: 1 }}>
                  <CustomTooltip
                    placement="top"
                    text={t(`PreviewAddressConsent`, {
                      defaultValue: `Address proof is required to open your account if your current home address is not available on your ID. You will need to provide a utility bill with your name and address issued within the last 60 days.`,
                    })}
                  />
                </span>
              </>
            )}
          </Box>

          {(((productMapping(productName) || location === HOME_PR || dgiMapping(productName)) &&
            location !== HOME_VI &&
            newAddress) ||
            addressInformation.utilityBill ||
            (addressInformation.vouchedAddressVerified === false && location !== HOME_VI) ||
            addressInformation.retainUtilityBill === true) &&
            isBundle(productName) && <BillTypeCustomCard handleChange={handleChange} />}

          {(!isBundle(productName) || addressInformation.utilityBill) && (
            <div style={{ marginTop: '5px' }}>
              <Box
                component="div"
                sx={[
                  classes.documentUploadContainer,
                  classes.uploadContainer,
                  classes.box,
                  classes.box_a,
                  pagePath === 'business-account-info' ? classes.busiAccWidth_box : '',
                  isBundle(productName)
                    ? {
                        backgroundColor: theme?.palette?.fieldsBackground?.main,
                        // border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                        color: theme?.palette?.secondary?.main,
                        backgroundSize: '1.5px 100%, 100% 1.5px, 1.5px 100%, 100% 1.5px',
                        '&:focus': {
                          backgroundImage:
                            'repeating-linear-gradient(0deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(90deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(180deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(270deg,blue,blue 7px,transparent 8px,transparent 15px)',
                          borderImage:
                            'repeating-linear-gradient(0deg, blue, blue 1px, transparent 1px, transparent 1px)',
                        },
                      }
                    : {
                        border: '1px dashed #808285',
                        background: '#F4F4F4',
                        '&:focus': {
                          backgroundImage:
                            'repeating-linear-gradient(0deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(90deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(180deg,blue,blue 7px,transparent 8px,transparent 15px), repeating-linear-gradient(270deg,blue,blue 7px,transparent 8px,transparent 15px)',
                          borderImage:
                            'repeating-linear-gradient(0deg, blue, blue 1px, transparent 1px, transparent 1px)',
                        },
                      },
                ]}
                id="uploadContainer"
              >
                {addressDocLoading && (
                  <Box component="div" sx={classes.errorImgPosition}>
                    <Loader />
                  </Box>
                )}

                {addressProofUploadStatus === null && !addressDocLoading && (
                  <Box component="div" sx={classes.uploadSecondaryContainer}>
                    <CloudUpload color={theme?.palette?.orientalPrimary?.main} />
                    <Box component="div" sx={classes.btn_grid_container}>
                      <Box component="div" sx={classes.btn_container}>
                        <Button
                          disableFocusRipple
                          color="inherit"
                          variant="outlined"
                          sx={[
                            classes.upload_icon_button,
                            classes.cameraBtn,
                            {
                              border: `1.6px solid ${theme?.palette?.orientalPrimary?.main}`,
                              color: theme?.palette?.orientalPrimary?.main,
                            },
                          ]}
                          startIcon={<CameraUpload color={theme?.palette?.orientalPrimary?.main} />}
                          onClick={routeToCameraUpload}
                          data-testid="camera_testid"
                        >
                          {t('Camera', { defaultValue: 'Camera' })}
                        </Button>
                      </Box>
                      <Box component="div" sx={classes.btn_container}>
                        <Button
                          disableFocusRipple
                          color="inherit"
                          id="uploadAddressProofInitial"
                          data-testid="null_testid"
                          onClick={(e) => buttonClickHandler(e)}
                          sx={[
                            classes.upload_icon_button,
                            classes.uploadBtn,
                            {
                              border: `1.6px solid ${theme?.palette?.orientalPrimary?.main}`,
                              color: theme?.palette?.orientalPrimary?.main,
                            },
                          ]}
                          startIcon={
                            <CloudUploadBtn color={theme?.palette?.orientalPrimary?.main} />
                          }
                        >
                          {t('Upload', { defaultValue: 'Upload' })}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
                {addressProofUploadStatus === DONE && !addressDocLoading && (
                  <Box component="div" sx={classes.statusContainer}>
                    <img
                      src={successUploadImg}
                      height="54px"
                      width="54px"
                      alt="Upload successful"
                    />
                    <Box
                      component="span"
                      sx={isBundle(productName) ? classes.doneTextBundle : classes.doneText}
                    >
                      {isBundle(productName)
                        ? t('Done!', { defaultValue: 'Done!' })
                        : t('Done', { defaultValue: 'Done' })}
                    </Box>
                  </Box>
                )}

                {addressProofUploadFail()}
              </Box>

              {!(isBundle(productName) && addressProofUploadStatus === DONE) && (
                <Box component="div" sx={classes.supportedText}>
                  <span
                    style={{
                      paddingRight: '10px',
                      color:
                        isBundle(productName) &&
                        addressProofUploadStatus === FAILED &&
                        !addressDocLoading
                          ? '#FF6971'
                          : '#727578',
                    }}
                  >
                    {t('Supported file types: PNG, JPG, PDF.', {
                      defaultValue: 'Supported file types: PNG, JPG, PDF.',
                      nsSeparator: '|',
                    })}
                  </span>
                  <span
                    style={{
                      paddingLeft: '10px',
                      color:
                        isBundle(productName) &&
                        addressProofUploadStatus === FAILED &&
                        !addressDocLoading
                          ? '#FF6971'
                          : '#727578',
                    }}
                  >
                    {t('Maximum: 10MB', {
                      defaultValue: 'Maximum: 10MB',
                      nsSeparator: '|',
                    })}
                  </span>
                </Box>
              )}

              {addressProofUploadStatus === FAILED && !addressDocLoading && !isBundle(productName) && (
                <Box
                  component="span"
                  id="addressUploadId"
                  sx={
                    isOcrErrMessageFound ||
                    (!addressInformation.ocrAddressVerified && productMapping(productName))
                      ? classes.ocrErrorStyle
                      : classes.errorStyle
                  }
                >
                  {isOcrErrMessageFound
                    ? t(addressInformation.ocrErrorMessage, {
                        defaultValue: addressInformation.ocrErrorMessage,
                        nsSeparator: '|',
                      })
                    : t(addressInformation.ocrUIErrors, {
                        defaultValue: addressInformation.ocrUIErrors,
                        nsSeparator: '|',
                      })}{' '}
                  <Box component="div" sx={classes.errorStyle}>
                    <Box
                      component="span"
                      sx={{ fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={(e) => buttonClickHandler(e)}
                      onKeyDown={(e) => buttonClickHandler(e)}
                      tabIndex={0}
                    >
                      {t('Click to upload again.', { defaultValue: 'Click to upload again.' })}
                    </Box>
                  </Box>
                </Box>
              )}
            </div>
          )}
        </Box>
      </Grid>
      {!isBundle(productName) && (
        <Grid size={{ xs: 12 }} sx={classes.id_upload_grid}>
          {vouchedEditAddrUploadNotDone()}
        </Grid>
      )}
    </Grid>
  );
}

DocumentUploadSidebar.propTypes = {
  pagePath: PropTypes.string,
  vouchedAddrEdited: PropTypes.bool,
  isBundleFlag: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  handleChange: PropTypes.func,
};

export default withRouter(DocumentUploadSidebar);
